import React, { useEffect, useState } from 'react';
import { Container, Box, Typography, Grid, Card, CardContent, CardMedia, Chip, Tabs, Tab } from '@mui/material';
import api, { getMediaUrl } from '../services/api';

const CaseStudies = () => {
  const [caseStudies, setCaseStudies] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');

  useEffect(() => {
    const fetchCases = async () => {
      try {
        const params = selectedCategory !== 'all' ? { category: selectedCategory } : {};
        const response = await api.get('/cases', { params });
        setCaseStudies(response.data);
        
        const cats = [...new Set(response.data.map(c => c.category))];
        setCategories(cats);
      } catch (error) {
        console.error('Error fetching case studies:', error);
      }
    };
    fetchCases();
  }, [selectedCategory]);

  return (
    <Container sx={{ py: 8 }}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography variant="h3" gutterBottom>
          Case Studies
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto' }}>
          Success stories and notable cases showcasing our expertise
        </Typography>
      </Box>

      <Box sx={{ mb: 4, borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={selectedCategory}
          onChange={(e, newValue) => setSelectedCategory(newValue)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="All" value="all" />
          {categories.map((cat) => (
            <Tab key={cat} label={cat} value={cat} />
          ))}
        </Tabs>
      </Box>

      <Grid container spacing={4}>
        {caseStudies.length > 0 ? (
          caseStudies.map((caseStudy) => (
            <Grid item xs={12} md={6} key={caseStudy._id}>
              <Card sx={{ height: '100%' }}>
                {caseStudy.image && (
                  <CardMedia
                    component="img"
                    height="250"
                    image={getMediaUrl(caseStudy.image)}
                    alt={caseStudy.title}
                  />
                )}
                <CardContent>
                  <Chip label={caseStudy.category} size="small" sx={{ mb: 2 }} />
                  <Typography variant="h5" gutterBottom>
                    {caseStudy.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    {caseStudy.description}
                  </Typography>
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle2" gutterBottom>
                      Challenge:
                    </Typography>
                    <Typography variant="body2" color="text.secondary" paragraph>
                      {caseStudy.challenge}
                    </Typography>
                    <Typography variant="subtitle2" gutterBottom>
                      Solution:
                    </Typography>
                    <Typography variant="body2" color="text.secondary" paragraph>
                      {caseStudy.solution}
                    </Typography>
                    <Typography variant="subtitle2" gutterBottom>
                      Result:
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {caseStudy.result}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Typography variant="body1" align="center" color="text.secondary">
              No case studies found. Please check back soon.
            </Typography>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default CaseStudies;

